import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MarketService } from '../../../shared/services/market.service';
import { Auth } from 'aws-amplify';


import { MatDialog } from "@angular/material/dialog";
import { ConfirmComponent } from "../../components/dialog/confirm/confirm.component";
import { Observable } from 'rxjs';


@Component({
  selector: 'app-view-properties',
  templateUrl: './view-properties.component.html',
  styleUrls: ['./view-properties.component.css'],
  providers: [MarketService]
})
export class ViewPropertiesComponent implements OnInit {
  [x: string]: any;


  isLoading: boolean = false;
  isPublish: boolean = false;
  isUnPublish: boolean = false;
  noDataFound: boolean = false;
  isDeleting: boolean = false;
  dummyData: Array<{}> = [];
  allProperties: Array<any> = [];
  deletedId: string = "";
  recievedProperty: any;
  owner: any;
  text = "cloud_queue"

  public icon = 'close'; 
  
  icons = [];


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private marketService: MarketService,
    public dialog: MatDialog,
    ) {this.getCurrentAuthenticatedUser(); }


  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {

      console.log("recieved property: ", params);
      this.recievedProperty = params;

    });

    this.getProperties();

    this.dummyData = [
      {
        "propertyId": "PROP-fcd87847-9c2a-488b-9fc5-ef0999a2df2c",
        "name": "Ganizani January 2023 Test",
        "status": "NEW",
        "type": "Sport",
        "industry": "Entertainment",
        "noOfDays": 30,
        "onSiteAttendance": 50,
        "eventSite": "Qatar",
        "category": "Sport",
        "description": "Ganizani Property Test Description January"
      }
    ]
  }

  confirmAndDeleteProperty(property: any): void {
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: '26.5rem',
      data: { 
        dialogTitle: 'Confirmation', 
        dialogMessageLine1: 'Are you sure want to delete this Property?',
        yesButtonText: 'Yes',
        noButtonText: 'No'
      }
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if ( !!result ) {
        //  this.deleteEmployee( id );
        console.log('Yes');
        this.onDeleteProperty(property);
      }
    });
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  public changeIcon(property: any){
    this.icons.splice(0, this.icons.length);
    console.log("eg:", property);
    if (property.status === "PUBLISHED"){
      console.log(property.status);
      this.onUnPublishProperty(property);
    } else {
      console.log(property.status);
      this.onPublishProperty(property);
    }
    // window.location.reload();
  }

  getProperties() {
    this.isLoading = true;

    this.marketService.getProperties(this.owner).subscribe((data) => {
      this.noDataFound = false;
      console.log("data:", data);

      data.forEach(x => {
        console.log("data:", x.status);
        if (x.status === "PUBLISHED") {
          this.text = "phonelink_off"
          console.log(this.text);
          this.icons.push(this.text);
        } else {
          this.text = "phonelink"
          console.log(this.text);
          this.icons.push(this.text);
        }
      }); 

      this.allProperties = data;

      this.isLoading = false;
    }, (error) => {
      this.allProperties = [];
      this.isLoading = false;
      this.noDataFound = true;
      console.log("err:", error);
    });

  }

  onAddProperty() {
    this.router.navigate(['/private-space/add-property', {}]);
  }

  onEditProperty(property: any) {

    this.router.navigate(
      ['/private-space/edit-property'],
      {
        relativeTo: this.route,
        queryParams: property,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  onDeleteProperty(property: any) {
    this.isLoading = true;
    this.isDeleting = true;
    this.deletedId = property.propertyId;

    this.marketService.deleteProperty(this.deletedId).subscribe((data) => {
      console.log("Deleted:", data);
      this.isDeleting = false;
      setTimeout(() => {
        this.getProperties()
        this.isLoading = false;
      }, 2500);

    }, (error) => {
      setTimeout(() => {
        this.getProperties()
      }, 2500);
      
      console.log("Error deleting:", error);
      this.isDeleting = false;
    });

  } 

  onViewProperty(property: any) {
    this.router.navigate(
      ['/private-space/view-single-property'],
      {
        relativeTo: this.route,
        queryParams: property,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  onPublishProperty(property: any) {
    this.isLoading = true;
    const editedProperty = property;
    console.log(editedProperty)

    editedProperty['status'] = "PUBLISHED";
    console.log("updatedProperty: ", editedProperty)

    this.marketService.editProperty(editedProperty).subscribe((data) => {
      console.log("Success: ", data);
      setTimeout(() => {
        this.isLoading = false;
        this.getProperties();
      }, 500); 
    }, (error) => {
      this.loading = false;
      console.log("Error: ", error);

    });
  }

  onUnPublishProperty(property: any) {
    this.isLoading = true;
    const editedProperty = property;
    console.log(editedProperty)

    editedProperty['status'] = "INACTIVE";
    console.log("updatedProperty: ", editedProperty)

    this.marketService.editProperty(editedProperty).subscribe((data) => {
      console.log("Success: ", data);
      setTimeout(() => {
        this.getProperties();
      }, 500); 
    }, (error) => {
      this.loading = false;
      console.log("Error: ", error);

    });
  }
}

